import React, { useState, useEffect, useContext } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { AppContext } from "../../../../context/Context";

const ColumnsChart2 = ({ firstColor, secondColor, height, datas }) => {
  const [data, setData] = useState([]);
  const [active, setActive] = useState();

  const { dataRange, clearState } = useContext(AppContext);

  useEffect(() => {
    if (dataRange === "All") {
      if (clearState === "") {
        setActive(true);
      } else if (clearState === null) {
        setTimeout(() => {
          setActive(true);
        }, 950);
      } else {
        setActive(false);
      }
    } else {
      if (clearState !== "") {
        setTimeout(() => {
          setActive(true);
        }, 950);
      }
    }
  }, [setActive, dataRange, clearState]);

  useEffect(() => {
    // Convert all revenues to positive but store original value
    const processedData = datas.map((item) => ({
      ...item,
      revenue: Math.abs(item.revenue),
      originalRevenue: item.revenue,
    }));
    setData(processedData);
  }, [datas]);

  // Format K / M for YAxis and LabelList
  const formatShort = (value) => {
    const abs = Math.abs(Number(value));
    if (abs >= 1_000_000) return `$${(abs / 1_000_000).toFixed(2)}M`;
    if (abs >= 1_000) return `$${(abs / 1_000).toFixed(0)}K`;
    return `$${abs}`;
  };

  // Format full USD detail for tooltip
  const formatUSD = (value) => {
    const absValue = Math.abs(Number(value));
    const formatted = absValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return Number(value) < 0 ? `($${formatted})` : `$${formatted}`;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ left: 30, top: 20 }}>
        <defs>
          <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={firstColor} />
            <stop offset="100%" stopColor={secondColor} />
          </linearGradient>
        </defs>

        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="month" />
        <YAxis
          tickFormatter={formatShort}
          domain={[0, "dataMax + 5000"]}
          style={{ marginLeft: 100 }}
        />
        <Tooltip
          formatter={(value, name, props) => {
            const original = props?.payload?.originalRevenue ?? value;
            return [formatUSD(original), "Total"];
          }}
          cursor={false}
        />
        <Bar
          dataKey="revenue"
          fill="url(#colorGradient)"
          barSize={50}
          radius={[5, 5, 0, 0]}
          animationDuration={1000}
          animationEasing="ease-in-out"
          cursor="pointer"
          isAnimationActive={active === true}
          animateNewValues={active === true}
        >
          <LabelList
            dataKey="originalRevenue"
            position="top"
            formatter={(value) => {
              const abs = Math.abs(Number(value));
              const formattedNumber = abs.toLocaleString(); // adds commas, e.g., 1,234,567
              return Number(value) < 0
                ? `($${formattedNumber})`
                : `$${formattedNumber}`;
            }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ColumnsChart2;
